import {serviceNotice} from '@/api-services'
import {errorHandler} from '@/utils/handler'
import {toast} from '@/utils/toast'
import {defineStore} from 'pinia'

export const useServiceNoticeStore = defineStore('serviceNoticeStore', {
  state: () => ({
    allNotices: [],
    districtDetail: {},
    readMark: {},
    loading: false,
    error: null,
  }),
  getters: {
    getNotificationCount(state) {
      return state.allNotices.filter((val) => val.read_at === null).length
    },
  },
  actions: {
    async getAllNotices() {
        this.loading = true
          try {
            const response = await serviceNotice.getAllNotices()
            const data = response.data
            this.allNotices = data
          } catch (error) {
            error.map((e) => {
              const errorMsg = errorHandler(e)
              this.error = errorMsg
              toast.error(errorMsg)
            })
          } finally {
            this.loading = false
          }
    },
    async markAsRead(id) {
      this.loading = true
        try {
          const response = await serviceNotice.markAsRead(id)
          const data = response.data
          this.allNotices = data
        } catch (error) {
          error.map((e) => {
            const errorMsg = errorHandler(e)
            this.error = errorMsg
            toast.error(errorMsg)
          })
        } finally {
          this.loading = false
        }
  },
  },
})
